import { openDB } from 'idb';
import { v4 as uuidv4 } from 'uuid';

const DB_NAME = 'orino_pos_storage';
const STORE_NAME = 'device';
const DEVICE_ID_KEY = 'device_id';

const getDb = async () => {
  return await openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });
};

export const getDeviceId = async (): Promise<string> => {
  try {
    const db = await getDb();
    const existingId = await db.get(STORE_NAME, DEVICE_ID_KEY);
    if (existingId) return existingId;

    const newId = uuidv4();
    await db.put(STORE_NAME, newId, DEVICE_ID_KEY);
    return newId;
  } catch (error) {
    console.error('Error accessing IndexedDB:', error);
    // Fallback to non-persistent UUID
    return uuidv4();
  }
};

export const initDeviceId = async (): Promise<void> => {
  try {
    const db = await getDb();
    const existingId = await db.get(STORE_NAME, DEVICE_ID_KEY);
    if (!existingId) {
      const newId = uuidv4();
      await db.put(STORE_NAME, newId, DEVICE_ID_KEY);
    }
  } catch (error) {
    console.error('Failed to initialize device ID:', error);
  }
};
